import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/home/Login'

import admin from './admin'
import admintraffic from './admintraffic'
import adminbusiness from './adminbusiness'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    admin,
    admintraffic,
    adminbusiness
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js